export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/system/sysCommon/query`,
          data
        });
      },
      saveCommonInfo(data) {
          return http.json({
              url: '/system/sysCommon/save',
              data
          })
      },
      getCommonInfo(data) {
          return http.json({
              url: `/system/sysCommon/get?id=${data.id}`
          })
      },
      removeCommon(data) {
          return http.json({
              url: `/system/sysCommon/delete?id=${data[0].id}`,
              data
          })
      },
      delCodeNum(data) {
          return http.json({
              url: `/common/del/code_num?phone=${data.phone}`
          })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/common.js